const classPrefix = 'summary-results'
const dataPrefix = 'data-summary-results'
const $container = document.querySelector(`[${dataPrefix}]`)
import GLightbox from 'glightbox';

if ($container) {
    summaryResults({$container})
}

export function summaryResults({$container}) {

    const $containerTemplate = document.querySelector(`[${dataPrefix}-container-template]`)
    const $answerTemplate = document.querySelector(`[${dataPrefix}-answer-template]`)

    let elements = [];
    const lightbox = GLightbox({
        selector: '.glightbox',
        openEffect: 'fade',
        closeEffect: 'fade'
    });
    //init();

    function init() {
        elements = [
            {
                answer: 'Я спросил когда это началось, чтобы установить временную линию проблемы, найти возможный триггер и определить динамику состояния, ухудшается ли ситуация.  ' +
                    'Этот вопрос — ключевая часть диагностики, которая помогает лучше понять суть проблемы и выбрать подходящие методы работы.',
                answers: [
                    {text: 'Расскажите о вашем дестве', is_correct: false, is_select: false, percent: 25},
                    {text: 'Что вы чувствуете по этому поводу?', is_correct: false, is_select: true, percent: 15},
                    {text: 'Когда это началось?', is_correct: true, is_select: false, percent: 30},
                    {text: 'Что собираетесь делать?', is_correct: false, is_select: false, percent: 30}
                ]
            },
            {
                answer: 'Я спросил когда это началось, чтобы установить временную линию проблемы, найти возможный триггер и определить динамику состояния, ухудшается ли ситуация.  ' +
                    'Этот вопрос — ключевая часть диагностики, которая помогает лучше понять суть проблемы и выбрать подходящие методы работы.',
                answers: [
                    {text: 'Расскажите о вашем дестве', is_correct: false, is_select: false, percent: 25},
                    {text: 'Что вы чувствуете по этому поводу?', is_correct: false, is_select: true, percent: 15},
                    {text: 'Когда это началось?', is_correct: true, is_select: false, percent: 30},
                    {text: 'Что собираетесь делать?', is_correct: false, is_select: false, percent: 30}
                ]
            },
            {
                answer: 'Я спросил когда это началось, чтобы установить временную линию проблемы, найти возможный триггер и определить динамику состояния, ухудшается ли ситуация.  ' +
                    'Этот вопрос — ключевая часть диагностики, которая помогает лучше понять суть проблемы и выбрать подходящие методы работы.',
                answers: [
                    {text: 'Расскажите о вашем дестве', is_correct: false, is_select: false, percent: 25},
                    {text: 'Что вы чувствуете по этому поводу?', is_correct: false, is_select: false, percent: 15},
                    {text: 'Когда это началось?', is_correct: true, is_select: true, percent: 30},
                    {text: 'Что собираетесь делать?', is_correct: false, is_select: false, percent: 30}
                ]
            },
        ];

        elements.forEach((element, index)=>{
            initContainer(element, index);
        })


    }

    function initContainer(element, index){
        const $containerClone = document.importNode($containerTemplate.content, true)

        const $question = $containerClone.querySelector(`[${dataPrefix}-question]`)
        const $list = $containerClone.querySelector(`[${dataPrefix}-list]`)
        const $answer = $containerClone.querySelector(`[${dataPrefix}-answer]`)


        $question.innerText = `Вопрос ${++index}`
        $answer.innerText = element.answer

        element.answers.forEach(answer=>{
            initAnswer($list, answer)
        })

        $container.appendChild($containerClone)

        // $controlPlay.addEventListener('click',  ()=>{
        //     $player.play();
        //     $controlPlay.style.display = 'none';
        //     $controlPause.style.display = 'flex';
        // });
        //
        // $controlPause.addEventListener('click', ()=>{
        //     $player.pause();
        //     $controlPause.style.display = 'none';
        //     $controlPlay.style.display = 'flex';
        // })
    }

    function initAnswer($answerContainer, answer)
    {

        const $answerClone = document.importNode($answerTemplate.content, true);

        const $item = $answerClone.querySelector(`[${dataPrefix}-item]`)
        const $fill = $answerClone.querySelector(`[${dataPrefix}-fill]`)
        const $text = $answerClone.querySelector(`[${dataPrefix}-text]`)
        const $percent = $answerClone.querySelector(`[${dataPrefix}-percent]`)
        const $icon = $answerClone.querySelector(`[${dataPrefix}-icon]`)


        $fill.style.width = `${answer.percent}%`
        $percent.innerText = `${answer.percent}%`
        $text.innerText = answer.text
        if (!answer.is_select)
        {
            $icon.style.display = 'none';
        }
        if (answer.is_correct){
            $item.classList.add(`${classPrefix}__container-content-question--correct`)
        }
        $answerContainer.appendChild($answerClone)
    }

}




